<template>
    <Dialog :header="$t('confirmDialogLoginHeader')" v-model:visible="visible" modal>
        <div class="formgrid" >
            <div class="my-3">
                <span class="p-float-label" >
                    <InputText style="padding-right: 2.5rem;" id="username" type="text" v-model="v$.formData.username.$model" :disabled="disabled" :class="{'p-invalid':v$.formData.username.$invalid && submitted, 'w-full': true}"/>
                    <label for="username" :class="{'p-error':v$.formData.username.$invalid && submitted}">{{$t('users.username')}}</label>
                </span>
                <small v-if="(v$.formData.username.$invalid && submitted) || v$.formData.username.$pending.$response" class="p-error">{{v$.formData.username.required.$message.replace('Value', 'Username')}}</small>
            </div>
            <div class="my-3 pt-3">
                <span class="p-float-label" >
                    <Password id="password" v-model="formData.password" :feedback="false" inputClass="w-full" toggleMask :class="{'p-invalid':v$.formData.password.$invalid && submitted, 'w-full': true}"></Password>
                    <label for="password" :class="{'p-error':v$.formData.password.$invalid && submitted}">{{$t('users.password')}}</label>
                </span>
                <small v-if="(v$.formData.password.$invalid && submitted) || v$.formData.password.$pending.$response" class="p-error">{{v$.formData.password.required.$message.replace('Value', 'Password')}}</small>
            </div>
        </div>
        <template #footer> 
            <Button icon="" :label="$t('btn.login')" type="submit" class="w-full" @click="onSubmit(!v$.$invalid)" />
        </template>
    </Dialog>
</template>

<script>
    import SecurityService from '../../services/security';
    import Dialog from 'primevue/dialog';
    import InputText from 'primevue/inputtext';
    import Button from 'primevue/button';
    import Password from 'primevue/password';
    import { required } from "@vuelidate/validators";
    import { useVuelidate } from "@vuelidate/core";

    export default {
        props: ['callback'],
        setup: () => ({ v$: useVuelidate() }),
        components: {
            Dialog, InputText, Password, Button
        },
        data(){
            return {
                visible: false,
                submitted: false,
                disabled: false,
                formData: {
                    username: null,
                    password: null
                }
            }
        },
        validations(){
           return {
                formData: {
                    username: {required},
                    password: {required}
                }
            }
        },
        methods: {
            show(){
                this.visible = true;
            },
            onSubmit(valid) {
                this.submitted = true;
                if (!valid) {
                    // this.$toast(message);
                }else{
                    this.$store.dispatch("generic/setLoading", true);
                    this.disabled = true;
                    this.visible = false;

                    SecurityService.login(this.formData, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        this.disabled = false;
                        if(response.success){
                            this.callback(response.token);
                        }else{
                            this.$toast.add({detail: response.message ?? "Autenticazione fallita. Controlla username e password", life:3000, severity:'error'});
                        }
                    });

                }
            }
        }
    }

</script>